import React from 'react';
import { Link } from 'react-router-dom';
import { FiKey, FiUserX } from 'react-icons/fi';
import { Trans } from 'react-i18next';
import { CampoSelect, CampoTexto } from './CamposFormulario';
import AsignadorServicios from './AsignadorServicios';
import FilaAjuste from '../../../../components/ui/FilaAjuste';
import { useTranslation } from 'react-i18next';
import { ROL_LABELS, DEPTO_LABELS, esStaff } from '../../../../constants/usuarios';

/** Permisos, servicios y seguridad. Solo para administradores. */
const FormularioAjustes = ({
  form, onCampo,
  catalogoServicios, serviciosAsignados, onAlternarServicio, cargandoServicios,
  reseteando, onResetearContrasena,
  onDarDeBaja, puedeDarDeBaja = false,
  esAdmin = true,
}) => {
  const { t } = useTranslation();
  const cambiar = (e) => onCampo(e.target.name, e.target.value);

  // Aviso en el propio campo: los correos mal escritos se descartarían al
  // enviar, así que se marcan mientras se escriben.
  const correosInvalidos = (form.emails_cc || '')
    .split(',')
    .map((correo) => correo.trim())
    .filter((correo) => correo !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo));

  const errorCorreosCc = correosInvalidos.length > 0
    ? t('perfilUsuario.correosCopiaInvalidos', { correos: correosInvalidos.join(', ') })
    : undefined;

  return (
    <>
      {esAdmin && (
        <>
          <FilaAjuste titulo={t('perfilUsuario.rol')} texto={t('perfilUsuario.filas.rolTexto')}>
            <div className={esStaff(form.role) ? 'fila-ajuste-pareja' : undefined}>
              <CampoSelect id="campo-rol" name="role" label={t('perfilUsuario.rol')} value={form.role} onChange={cambiar}>
                {Object.entries(ROL_LABELS).reverse().map(([valor, label]) => (
                  <option key={valor} value={valor}>{label}</option>
                ))}
              </CampoSelect>

              {esStaff(form.role) && (
                <CampoSelect
                  id="campo-dpto"
                  name="dpto_tecnico"
                  label={t('perfilUsuario.departamentoTecnico')}
                  value={form.dpto_tecnico}
                  onChange={cambiar}
                >
                  {Object.entries(DEPTO_LABELS).map(([valor, label]) => (
                    <option key={valor} value={valor}>{label}</option>
                  ))}
                </CampoSelect>
              )}
            </div>
          </FilaAjuste>

          <FilaAjuste titulo={t('perfilUsuario.estadoCuenta')} texto={t('perfilUsuario.hintSinVerificar')}>
            <CampoSelect
              id="campo-estado"
              name="estado"
              label={t('perfilUsuario.estadoCuenta')}
              ocultarLabel
              value={form.estado}
              onChange={cambiar}
            >
              <option value="verificar">{t('perfilUsuario.verificarOpcion')}</option>
              <option value="verificado">{t('perfilUsuario.verificadoOpcion')}</option>
              <option value="suspendido">{t('perfilUsuario.suspendidoOpcion')}</option>
              {/* Se pone desde "dar de baja"; aquí sirve para revertirlo */}
              <option value="archivado">{t('usuarios.estados.archivado')}</option>
            </CampoSelect>
          </FilaAjuste>
        </>
      )}

      {/* Correos en copia: lo gestionan tanto técnicos como administradores */}
      <FilaAjuste titulo={t('perfilUsuario.correosCopia')} texto={t('perfilUsuario.filas.ccTexto')}>
        <CampoTexto
          id="campo-emails-cc"
          name="emails_cc"
          label={t('perfilUsuario.correosCopia')}
          ocultarLabel
          hint={t('perfilUsuario.filas.ccHint')}
          placeholder={t('perfilUsuario.correosCopiaPlaceholder')}
          value={form.emails_cc}
          onChange={cambiar}
          error={errorCorreosCc}
        />
      </FilaAjuste>

      {esAdmin && (
        <>
          <FilaAjuste
            titulo={t('perfilUsuario.serviciosContratados')}
            ancho
            texto={<Trans i18nKey="perfilUsuario.marcaServiciosHint" components={{ enlace: <Link to="/dashboard/gestion-servicios" /> }} />}
          >
            <div role="group" aria-label={t('perfilUsuario.serviciosAsignados')}>
              {cargandoServicios ? (
                <p className="pu-srv-vacio">{t('perfilUsuario.cargandoCatalogo')}</p>
              ) : (
                <AsignadorServicios
                  catalogo={catalogoServicios}
                  seleccionados={serviciosAsignados}
                  onAlternar={onAlternarServicio}
                />
              )}
            </div>
          </FilaAjuste>

          <FilaAjuste titulo={t('perfilUsuario.contrasena')} texto={t('perfilUsuario.generarContrasenaHint')}>
            <button
              type="button"
              className="pu-btn-secundario"
              onClick={onResetearContrasena}
              disabled={reseteando}
            >
              <FiKey /> {reseteando ? t('perfilUsuario.reseteando') : t('perfilUsuario.resetearContrasena')}
            </button>
          </FilaAjuste>

          {puedeDarDeBaja && (
            <FilaAjuste titulo={t('bajaUsuario.darDeBaja')} texto={t('bajaUsuario.darDeBajaHint')} peligro>
              <button type="button" className="pu-btn-peligro" onClick={onDarDeBaja}>
                <FiUserX /> {t('bajaUsuario.darDeBaja')}
              </button>
            </FilaAjuste>
          )}
        </>
      )}
    </>
  );
};

export default FormularioAjustes;
